export default __webpack_public_path__ + "static/media/warning.9c9b6eef.svg";